import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    padding: "30px 20px",
  },
  leftPart: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  rightPart: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
  },
  imgContainer: {
    width: "60px",
    height: "60px",
    [theme.breakpoints.down("sm")]: {
      width: "50px",
      height: "50px",
    },
    borderRadius: "8px",
  },
  cardImage: {
    borderRadius: "50px",
    width: "60px",
    height: "60px",
    [theme.breakpoints.down("sm")]: {
      width: "50px",
      height: "50px",
    },
  },
  value: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "38px",
    // lineHeight: "100%",
    letterSpacing: "1px",
    color: "#272525",
  },
  text: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "16px",
    color: "#999999",
  },
}));

export default useStyles;
